

// WARN: All keys MUST be unique, even if text value is the same
const abuse = {
  physicalVictim: "Physical victim",
  physicalPerpetrator: "Physical perpetrator",
  sexualVictim: "Sexual victim",
  sexualPerpetrator: "Sexual perpetrator",
  emotionalVictim: "Emotional victim",
  emotionalPerpetrator: "Emotional perpetrator",
  neglectVictim: "Neglect victim",
};

const behavioural = {
  physicalAggression: "Physical aggression",
  flightRisk: "Flight risk",
  arsonist: "Arsonist",
  propertyDamage: "Property damage",
  oppositionalDefiantDisorder: "Oppositional Defiant Disorder",
  conductDisorder: "Conduct Disorder",
  pastCriminalAndAntisocialBehaviours: "Past criminal and antisocial behaviours",
  supportsThoseOnBail: "Those on bail",
};

const mentalHealth = {
  selfHarm: "Self harm",
  eatingDisorders: "Eating disorders",
  postTraumaticStressDisorder: "Post Traumatic Stress Disorder",
  bipolar: "Bipolar",
  schizophrenia: "Schizophrenia",
  developmentalDelay: "Developmental delay",
  complexEmotionalTrauma: "Complex emotional trauma",
};

const riskToStaff = {
  riskToStaffPhysical: "Physical",
  riskToStaffSexual: "Sexual",
  riskToStaffVerbal: "Verbal",
  riskToStaffPsychological: "Psychological",
};

const riskToPeers = {
  riskToPeersPhysical: "Physical",
  riskToPeersSexual: "Sexual",
  riskToPeersVerbal: "Verbal",
  riskToPeersPsychological: "Psychological",
};

const riskToFromCommunity = {
  offendingBehaviours: "Offending behaviours",
  childSexualExploitation: "Child Sexual Exploitation",
  childCriminalExploitation: "Child Criminal Exploitation",
  highProfileCase: "High profile case",
};

const neurodivergence = {
  adhd: "ADHD",
  add: "ADD",
  autism: "Autism",
  asperges: "Asperges",
};

export const supportNeeds = {
  abuse: {
    title: "Abuse",
    key: "abuse",
    items: abuse,
  },
  behavioural: {
    title: "Behavioural",
    key: "behavioural",
    items: behavioural,
  },
  mentalHealth: {
    title: "Mental Health",
    key: "mentalHealth",
    items: mentalHealth,
  },
  riskToStaff: {
    title: "Risk To Staff",
    key: "riskToStaff",
    items: riskToStaff,
  },
  riskToPeers: {
    title: "Risk To Peers",
    key: "riskToPeers",
    items: riskToPeers,
  },
  riskToFromCommunity: {
    title: "Community Risk",
    key: "riskToFromCommunity",
    items: riskToFromCommunity,
  },
  neurodivergence: {
    title: "Neurodivergence",
    key: "neurodivergence",
    items: neurodivergence,
  },
};

export const individualNeedsMap = {
  physicalVictim: "Physical victim",
  sexualVictim: "Sexual victim",
  emotionalVictim: "Emotional victim",
  neglectVictim: "Neglect victim",
  ...mentalHealth,
  ...neurodivergence,
};

export const allNeedsMap = {
  ...abuse,
  ...behavioural,
  ...mentalHealth,
  ...riskToStaff,
  ...riskToPeers,
  ...riskToFromCommunity,
  ...neurodivergence,
};

export const risksMap = {
  physicalPerpetrator: "Physical perpetrator",
  sexualPerpetrator: "Sexual perpetrator",
  emotionalPerpetrator: "Emotional perpetrator",
  ...riskToStaff,
  ...riskToPeers,
  ...riskToFromCommunity,
  ...behavioural,
};

export function getFiltersToSave(data) {
  const values = {};
  const needsKeys = Object.keys(supportNeeds);
  let needsList = [];

  // Loop over support needs
  needsKeys.forEach((needs) => {
    needsList = [...needsList, ...Object.keys(supportNeeds[needs].items)];
  });

  // Loop over support needs KEYS and map to the form DATA value
  needsList.forEach((needsKey) => {
    values[needsKey] = data[needsKey];
  });

  return values;
}